import { Button, Col, Divider, Input, Row, Spin } from "antd";
import { useDepartureClient } from "../../../../../hooks/order_list_views/useDeparturesClient.hook";
import DepartureInfo from "./departure_info";

export default function DeparturesClient(){
    
    const hook = useDepartureClient()
    
    if(hook.loading) return(<Spin />);
    return(
        <Row>
            <Col xs={2} lg={2}>
            </Col>
            <Col lg={12} xs={22}>
                <div style={{ margin: '20px 10px', fontSize: '1.1em', fontWeight: 'bold'}}>Despachos {hook.data.length > 0 ? hook.data[0].client_name : ''}</div>
            </Col>
            <Col lg={10} xs={24}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ margin: '0 10px' }}>Filtro:</div>
                    <Input 
                        style={{ margin: '0 10px' }}
                        defaultValue={hook.filter}
                        onChange={(e) => {
                            hook.setFilter(e.target.value);
                        }}
                    />
                    <Button 
                        type="primary"
                        onClick={() => {
                            hook.dynamicLoad();
                        }}
                    >
                        Filtrar
                    </Button>
                </div>
            </Col>
            <Col lg={24} xs={24}>
                <Divider />
            </Col>
            <Col lg={24} xs={24}>
            {
                hook.loading &&
                <Spin />
            }
            <DepartureInfo
                hook={hook}
            />
            </Col>
        </Row>   
    );
}